var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page not-found h100"},[_c('div',{staticClass:"d-flex justify-content-center flex-column align-items-center h100"},[_vm._v(" Page Not Found "),_c('div',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Go to home")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }